module.exports = __webpack_public_path__ + "img/shop1_2.24ffa0f3.png";